/* KAARKASH: the photographs of the editorial product page, opened full screen to look
   closely, as the reference opens its own: PhotoSwipe (assets/photoswipe.umd.min.js, MIT,
   (c) Dmytro Semenov), fetched the first time a photograph is opened. Its plain-script
   build, not the module one: Shopify minifies theme scripts as it serves them and turns an
   import() into a require(), which a browser does not have. Look:
   assets/kk-product.css ("the photographs, full screen").
   - A press on a photograph opens it whole, on white; the others are a swipe, an arrow or
     an arrow key away, and the counter says which one it is.
   - Closer: a click or a double tap zooms in 2.5 times at the place pressed (the store's
     photographs are 900px wide, so their own size would hardly be closer); the wheel, a
     pinch or the zoom button zoom by degrees, up to 5 times; a zoomed photograph is moved by
     dragging it. Escape, × or a swipe down closes it, and the focus goes back to where it was.
   - The shopper never leaves the page: if the viewer cannot start, Dawn's own full-screen
     photographs open instead.
   The full-size file of each photograph, and its size, are on its frame (data-kkz-src, -w,
   -h: snippets/product-thumbnail.liquid). A film has none, and is left to Dawn's player. */
(function () {
  'use strict';
  if (window.__kkZoom) return;
  window.__kkZoom = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var loading = null;
  var busy = false;     // a viewer is opening or open: a second press waits for it

  function core(url) {
    if (window.PhotoSwipe) return Promise.resolve(window.PhotoSwipe);
    if (!loading) {
      loading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = function () { if (window.PhotoSwipe) resolve(window.PhotoSwipe); else reject(new Error('PhotoSwipe did not start')); };
        s.onerror = function () { reject(new Error('PhotoSwipe could not be fetched')); };
        document.head.appendChild(s);
      });
    }
    return loading;
  }

  function photographs(gallery) {
    return Array.prototype.map.call(gallery.querySelectorAll('[data-kkz-src]'), function (frame) {
      var img = frame.querySelector('img');
      return {
        frame: frame,
        src: frame.getAttribute('data-kkz-src'),
        width: parseInt(frame.getAttribute('data-kkz-w'), 10) || 1600,
        height: parseInt(frame.getAttribute('data-kkz-h'), 10) || 2000,
        msrc: img && !img.hasAttribute('data-src') ? img.currentSrc || img.src : '',
        alt: img ? img.alt : '',
        element: img || frame,
      };
    });
  }

  function open(root, frame, toggle) {
    if (busy) return;
    busy = true;
    var gallery = root.querySelector('media-gallery');
    var list = photographs(gallery);
    var index = 0;
    for (var i = 0; i < list.length; i++) if (list[i].frame === frame) index = i;
    core(root.getAttribute('data-kkz-core')).then(function (PhotoSwipe) {
      var still = reduced.matches;
      var viewer = new PhotoSwipe({
        dataSource: list,
        index: index,
        mainClass: 'kkz',
        bgOpacity: 1,
        showHideAnimationType: 'fade',
        showAnimationDuration: still ? 0 : 300,
        hideAnimationDuration: still ? 0 : 250,
        zoomAnimationDuration: still ? 0 : 333,
        initialZoomLevel: 'fit',
        secondaryZoomLevel: function (zoom) { return Math.max(zoom.fit * 2.5, Math.min(1, zoom.fit * 3)); },
        maxZoomLevel: function (zoom) { return Math.max(zoom.fit * 5, 1); },
        imageClickAction: 'zoom',
        wheelToZoom: true,
        padding: { top: 0, bottom: 0, left: 0, right: 0 },
        indexIndicatorSep: ' / ',
        closeTitle: 'Close',
        zoomTitle: 'Zoom in or out',
        arrowPrevTitle: 'Previous photograph',
        arrowNextTitle: 'Next photograph',
        errorMsg: 'This photograph could not be loaded.',
      });
      viewer.on('destroy', function () { busy = false; });
      viewer.init();
    }).catch(function (err) {
      busy = false;
      // the viewer could not be fetched or started: Dawn's own full-screen photographs,
      // on this page (never a new tab: the shopper would be leaving the store)
      if (window.console) console.error('kk-zoom', err);
      loading = null;
      var dawn = root.querySelector('product-modal');
      if (dawn && dawn.show && toggle) dawn.show(toggle);
    });
  }

  // Heard first (capturing), so Dawn's own full-screen list never opens over it.
  document.addEventListener('click', function (e) {
    var root = e.target.closest && e.target.closest('product-info.kkp[data-kkz-core]');
    if (!root) return;
    var item = e.target.closest('.product__media-item');
    var gallery = root.querySelector('media-gallery');
    if (!item || !gallery || !gallery.contains(item)) return;
    var frame = item.querySelector('[data-kkz-src]');
    if (!frame) return;
    e.preventDefault();
    e.stopPropagation();
    open(root, frame, item.querySelector('.product__media-toggle'));
  }, true);
})();
